import { keyframes, style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const navItemStyles = style({
  width: "max-content",
  listStyle: "none",
  textWrap: "nowrap",
});

const sharedPseudoStyles = {
  content: "",
  position: "absolute" as const, // Needed to stop typescript error
  bottom: 0,
  height: 4,
  backgroundColor: vars.colors.white,
};

export const activeLinkStyles = style({
  fontFamily: vars.fonts.bold,
  "::before": {
    ...sharedPseudoStyles,
    insetInlineStart: 0,
    width: "50%",
  },
  "::after": {
    ...sharedPseudoStyles,
    insetInlineEnd: 0,
    width: "50%",
  },
});

// Animated selection indicator for links. Requires two animations and two pseudo elements.
// Expand to the right from the center
const expandRight = keyframes({
  "0%": { insetInlineStart: "50%", width: "0%" },
  "100%": { insetInlineStart: "50%", width: "50%" },
});

// Expand to the left from the center
const expandLeft = keyframes({
  "0%": { insetInlineEnd: "50%", width: "0%" },
  "100%": { insetInlineEnd: "50%", width: "50%" },
});

const contractRight = keyframes({
  "0%": { insetInlineStart: "50%", width: "50%" },
  "100%": { insetInlineStart: "50%", width: "0%" },
});

const contractLeft = keyframes({
  "0%": { insetInlineEnd: "50%", width: "50%" },
  "100%": { insetInlineEnd: "50%", width: "0%" },
});

export const navLinkStyles = style({
  position: "relative",
  display: "inline-block",
  cursor: "pointer",
  paddingBlock: 10,
  textDecoration: "none",
  color: vars.colors.white,

  selectors: {
    // Common styles for both pseudo elements
    "&::before, &::after": {
      ...sharedPseudoStyles,
    },

    "&::before": {
      borderStartStartRadius: vars.radii.xs,
    },
    "&::after": {
      borderStartEndRadius: vars.radii.xs,
    },

    // Right expanding line, only plays when not active link
    [`&:not(${activeLinkStyles}):hover::after`]: {
      animation: `${expandRight} 0.1s ease-in-out forwards`,
    },

    // Left expanding line, only plays when not active link
    [`&:not(${activeLinkStyles}):hover::before`]: {
      animation: `${expandLeft} 0.1s ease-in-out forwards`,
    },

    [`&:not(${activeLinkStyles})::after`]: {
      animation: `${contractRight} 0.1s ease-in-out forwards`,
    },
    [`&:not(${activeLinkStyles})::before`]: {
      animation: `${contractLeft} 0.1s ease-in-out forwards`,
    },
  },

  "@media": {
    "(prefers-reduced-motion: reduce)": {
      selectors: {
        "&::before, &::after": {
          animation: "none !important",
        },
      },
    },
  },
});
